<section class="form-card">
  <header class="login-card-header">
    <img class="login-card-title" src="assets/img/login/forgotten-password.svg">
    <h3 class="login-card-subtitle">Pour profiter de tous mes avantages …</h3>
  </header>

  <section class="login-card-body">
    <p>La réinitialisation du mot de passe est prise en charge par le service d’identité Castorama.</p>

    <div class="form-row">
      <div class="form-col text-end">
        <a (click)="onSwitchContext(LoginContext.login)"
           class="casto-link forgotten-password-link">Me connecter</a>
      </div>
    </div>
  </section>

  <footer class="login-card-footer">
    <ng-casto-btn class="blue"
                  label="Réinitialiser mon mot de passe"
                  (click)="forgottenPassword()"
                  [loading]="loading"></ng-casto-btn>
  </footer>
</section>
